<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";

import { useIsTouch } from "@/composables/shared/useIsTouch";

defineProps<{
  showEdit?: boolean;
  disabled?: boolean;
}>();

const emit = defineEmits<{
  edit: [];
  remove: [];
}>();

const { t } = useI18n();

const isTouch = useIsTouch();

const buttonSize = computed(() => (isTouch.value ? "default" : "small"));
</script>

<template>
  <div
    class="upload-overlay-reveal tw:pointer-events-none tw:absolute tw:inset-0 tw:bg-black/10 tw:opacity-0 tw:transition-opacity tw:duration-200 tw:group-hover:opacity-100"
  />
  <div
    class="upload-overlay-reveal tw:absolute tw:top-3 tw:right-3 tw:flex tw:gap-2 tw:opacity-0 tw:transition-opacity tw:duration-200 tw:group-hover:opacity-100"
  >
    <v-btn
      v-if="showEdit"
      icon="mdi-pencil"
      :size="buttonSize"
      variant="flat"
      color="secondary"
      class="tw:!shadow-md"
      :aria-label="t('generic.action.edit')"
      :disabled="disabled"
      @click="emit('edit')"
    />

    <v-btn
      icon="mdi-trash-can-outline"
      :size="buttonSize"
      variant="flat"
      color="error"
      class="tw:!shadow-md"
      :aria-label="t('generic.action.remove')"
      :disabled="disabled"
      @click="emit('remove')"
    />
  </div>
</template>

<style scoped>
/* `group-hover` never fires on a touchscreen, so the edit/remove buttons stay invisible
   and effectively unreachable on mobile. */
@media (hover: none) {
  .upload-overlay-reveal {
    opacity: 1 !important;
  }
}
</style>
